import { c as _c } from "react/compiler-runtime";
import { Box, Divider, IconButton, Stack, Typography } from '@mui/material';
import classnames from 'classnames';
import { getTestId } from './panelTestId';
export interface PanelHeaderProps {
  onClose?: () => void;
  onBack?: () => void;
  hideBorder?: boolean;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  alignTitles?: boolean;
  testIdPrefix?: string;
  fullWidthSubtitle?: boolean;
  closeIconClass?: string;
}
export const PanelHeader = props => {
  const $ = _c(32);
  const {
    title,
    subtitle,
    actions,
    testIdPrefix,
    onClose,
    onBack,
    hideBorder,
    alignTitles,
    fullWidthSubtitle: t0,
    closeIconClass: t1
  } = props;
  const fullWidthSubtitle = t0 === undefined ? true : t0;
  const closeIconClass = t1 === undefined ? "material-symbols-close-rounded" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      justifyContent: "space-between",
      alignItems: "center",
      padding: "16px 24px"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "center",
      gap: "12px"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== onBack) {
    t4 = onBack && <IconButton data-testid="header-back-button" onClick={onBack} sx={{
      color: "var(--mui-palette-text-primary)"
    }}><i className="material-symbols-chevron-left-rounded" /></IconButton>;
    $[2] = onBack;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== testIdPrefix || $[5] !== title) {
    t5 = typeof title === "string" ? <Typography variant="h3" data-testid={getTestId(testIdPrefix, "side-panel-title")}>{title}</Typography> : title;
    $[4] = testIdPrefix;
    $[5] = title;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <Stack className="flex-1">{t5}</Stack>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <Stack direction="row" className="flex-1" sx={t3}>{t4}{t6}</Stack>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== closeIconClass || $[13] !== onClose || $[14] !== testIdPrefix) {
    t8 = onClose && <IconButton onClick={onClose} data-testid={getTestId(testIdPrefix, "side-panel-close-button")} sx={{
      color: "var(--mui-palette-text-primary)"
    }}><i className={closeIconClass} /></IconButton>;
    $[12] = closeIconClass;
    $[13] = onClose;
    $[14] = testIdPrefix;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== actions || $[17] !== t8) {
    t9 = <div className="flex gap-4 items-center">{actions}{t8}</div>;
    $[16] = actions;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <Stack direction="row" sx={t2}>{t7}{t9}</Stack>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== alignTitles || $[23] !== fullWidthSubtitle || $[24] !== subtitle) {
    t11 = subtitle && <Box className={classnames([{
      "ml-[24px]": alignTitles,
      "ml-[40px]": !alignTitles,
      "max-w-[580px]": !fullWidthSubtitle
    }, "mb-[20px] mt-[8px] mr-[24px]"])}>{typeof subtitle === "string" ? <Typography variant="body1">{subtitle}</Typography> : subtitle}</Box>;
    $[22] = alignTitles;
    $[23] = fullWidthSubtitle;
    $[24] = subtitle;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== hideBorder) {
    t12 = !hideBorder && <Divider />;
    $[26] = hideBorder;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t12) {
    t13 = <Stack>{t10}{t11}{t12}</Stack>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};